import { Component, OnInit, Injector, Input } from '@angular/core';
import { TableAbstractComponent } from 'src/app/common-page-components/classes/table-abstract-component';
import { MembersAthletesFiltersServiceService } from '../services/members-athletes-filters-service.service';
import { HttpClient } from '@angular/common/http';
import MemberAssociationsStore from '../../../../common-page-components/stores/entities-store/continental-associations-store';
import { combineLatest, map, tap, mergeMap, filter, first } from 'rxjs/operators';
import { IHeaderConfig } from 'src/app/common-page-components/headers-component/headers-component.component';
import { FederationAthleteStore } from '../../../../common-page-components/stores/entities-store/federation-athlete-store';
import { CategoryItem } from 'world-archery-lib';
import { ICategoryCombo } from 'src/app/common-page-components/stores/filters-store/filters-store';
import { Router } from '@angular/router';
import { ActivationEnd } from '@angular/router';

/**
 * Shows member association athletes.
 *
 * @export
 * @class MembersAthletesTableComponent
 * @extends {TableAbstractComponent}
 * @implements {OnInit}
 */
@Component({
  selector: 'app-bootstrap-members-athletes-table',
  templateUrl: './bootstrap-members-athletes-table.component.html',
  styleUrls: ['./bootstrap-members-athletes-table.component.scss']
})
export class MembersAthletesTableComponent extends TableAbstractComponent implements OnInit {

  /**
   * Field if this table is reused. -This is the index of filter that contains category combo
   *
   * @type {number}
   * @memberof MembersAthletesTableComponent
   */
  @Input()
  indexOfCategoryCombo: number = 1;
  categories: Object = [];
  currentCategory: ICategoryCombo;

  countryCode:string;

  /**
   * Creates an instance of MembersAthletesTableComponent.
   *
   * @param {Injector} injector
   * @param {MembersAthletesFiltersServiceService} filters_services
   *   Filters for member athletes.
   * @param {HttpClient} http
   *
   * @memberof MembersAthletesTableComponent
   */
  constructor(injector: Injector, public router:Router, public filters_services: MembersAthletesFiltersServiceService, http: HttpClient) {
    super(injector, filters_services, new FederationAthleteStore(http, injector));
    this.filter_service.sortLocator.sortingType = 'RANKING' as any;
    this.filter_service.sortLocator.asc = true;
    this.router.events.pipe(
      filter(a => a instanceof ActivationEnd),
      first(),
      map((a: ActivationEnd) => a.snapshot.params.noc)).subscribe(countryCode => this.countryCode=countryCode)
  }

  /**
   * Implements ngOnInit().
   *
   * @memberof MembersAthletesTableComponent
   */
  ngOnInit() {
    this.filters_services.getDataStreamWithFilters().pipe(
      combineLatest([this.reload.asObservable()]),
      map(([a, b]) => a), map(([order, text, category, active]) => {
        this.currentCategory = category;
        const params = {
          CatId: category ? category.Id : undefined,
          Name: text.text,
          SortBy: order.sortingSend,
          Country: this.countryCode,
          Active: active.Name === 'Active and inactive' ? 0 : active.Name === 'Active' ? 1 : -1
        };
        return params;
      }), mergeMap(params => this.model.requestData(params, this.request_more_data)
      )).subscribe();
    // Set all categories, keyed by category code so we can add behaviours when an athlete category
    // is selected.
    this.filter_service.filtersType[this.indexOfCategoryCombo].options.options_subject.asObservable().subscribe((categories) => {
      this.categories = {};
      for (var key in categories) {
        this.categories[categories[key].Code] = categories[key];
      }
    });
  }

  /**
   * Build headers of this page.
   *
   * The headers are different when isn't a selected category.
   */
  headers() {
    let headers = [
      { name: '', isSortable: false, sortProperty: '' },
      { name: 'Name', isSortable: true, sortProperty: 'NAME' },
      { name: "Age", isSortable: true, sortProperty: 'AGE' },
      { name: 'World Ranking', isSortable: true, sortProperty: 'RANKING' },
    ];
    if (!this.categorySelected()) {
      headers = headers.concat([
        { name: 'Category', isSortable: false, sortProperty: '', classes: ['center-text'] } as any,
      ]);
    }
    else {
      headers = headers.concat([
        { name: 'Average Arrow', isSortable: true, sortProperty: 'ARROWAVG' },
        { name: 'Match Wins', isSortable: true, sortProperty: 'MATCHWIN' }
      ]) as any;
    }
    return headers;
  }

  /**
   * Obtain a category by code.
   *
   * @param {string} categoryCode
   *   Category code.
   *
   * @returns {ICategoryCombo}
   *   Category obtained by that code.
   *
   * @memberof MembersAthletesTableComponent
   */
  getCategoryByCode(categoryCode): ICategoryCombo {
    return this.categories[categoryCode];
  }

  /**
   * Check if a category has been selected.
   *
   * @returns {boolean}
   *   TRUE if category is not empty and is not All.
   *
   * @memberof MembersAthletesTableComponent
   */
  categorySelected(): boolean {
    return this.currentCategory !== undefined && this.currentCategory.Name !== 'All';
  }

  /**
   * Select a category.
   *
   * @param {CategoryItem} category
   *   Category selected.
   *
   * @memberof MembersAthletesTableComponent
   */
  selectCategory(category) {
    this.filter_service.filtersType[this.indexOfCategoryCombo].options.options_selected_subject.next(category);
  }

}
